import styled from "styled-components";
import { styled as styledMui } from "@material-ui/core/styles"
import { Avatar, Button } from "@material-ui/core"

export const ExtraTableButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 2rem;
    .icon-container {
        cursor: pointer;

        svg {
            width: 2rem;
            height: 2rem;
        }
        
    }
     /* @media only screen and (max-width: 564px) {
        flex-direction: column;
     } */
`

export const InstructorButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 1.3rem;
    @media only screen and (max-width: 764px) {
        flex-direction: column;
        /* margin-top:20px; */
     }
`
export const DeleteInstructorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.8rem;

    .title {
        font-weight: 700;
        font-size: 1.8rem;
        color: #2196F3;
    }

    .sub-title {
        font-weight: 700;
        font-size: 1.2rem;
        color: #969696;
    }

    .button-container {
        display: flex;
        align-items: center;
        gap: 1.7rem;
    }
`

export const InstructorCustomAvatar = styledMui(Avatar)(({ theme }) => ({
    width: '13.3rem',
    height: '13.3rem',
}));